export const POPOUT_WAIT_DELAY = 1500;